import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/services";

export const Header = () => {
    return (
        <motion.header
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="fixed top-0 left-0 right-0 z-50 bg-cream/90 backdrop-blur-md border-b border-line"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
                <a href="#inicio" data-testid="header-logo" className="flex items-center gap-3">
                    <img
                        src="/media/logo.jpeg"
                        alt="AS Studio — Agencia digital en Alicante"
                        className="h-12 w-12 object-cover logo-blend"
                    />
                    <span className="font-display text-2xl font-bold tracking-tight">
                        AS<span className="text-coral">.</span>Studio
                    </span>
                </a>
                <nav className="hidden md:flex items-center gap-8 font-mono text-xs uppercase tracking-[0.2em]">
                    <a data-testid="nav-servicios" href="#servicios" className="hover:text-coral transition-colors duration-300">
                        Servicios
                    </a>
                    <a data-testid="nav-estudio" href="#estudio" className="hover:text-coral transition-colors duration-300">
                        Estudio
                    </a>
                    <a data-testid="nav-video" href="#video" className="hover:text-coral transition-colors duration-300">
                        Vídeo
                    </a>
                </nav>
                <a
                    data-testid="header-whatsapp-btn"
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-navy text-cream px-5 py-2.5 font-mono text-xs uppercase tracking-[0.15em] hover:bg-coral hover:text-navy transition-colors duration-300"
                >
                    <MessageCircle size={16} />
                    <span className="hidden sm:inline">WhatsApp</span>
                </a>
            </div>
        </motion.header>
    );
};
